import React, {useEffect, useState} from 'react';

import { createRoot } from 'react-dom/client';

import {formatMoney, formatRace} from '../../common';

const EmailPreview = () => {

  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get('/api/welcome/email-preview')
         .then(response => {
            //console.log('response', response)
            setData(response.data);
          })
          .catch(error => {
            console.log('error', error)
          });
  }, []);

  if (! data)
  {
    return null;
  }

  const raceState = data.race.slice(0, 2).toLowerCase();

  return (
    <>
      <h2>{formatRace(data.race)} Alert, 527 Tracker</h2>
      <hr />
      <h3 style={raceState ? {backgroundImage: `url(/assets/state_${raceState}.png)`} : null}>
        <span className="text-primary">Race Alert</span><br />{formatRace(data.race)}
      </h3>
      <hr />
      <h4>Total Expenditures</h4>
      <h5>{formatMoney(data.total)}</h5>
    </>
  );
};

if (document.getElementById('email-preview')) {
  const root = createRoot(document.getElementById('email-preview'));
  root.render(<EmailPreview />);
}
